import { render } from "./ShippingAddressForOrder.html?vue&type=template&id=28fb6c1b&scoped=true"
import script from "./ShippingAddressForOrder.js?vue&type=script&lang=js"
export * from "./ShippingAddressForOrder.js?vue&type=script&lang=js"

import "./ShippingAddressForOrder.css?vue&type=style&index=0&id=28fb6c1b&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fb6c1b"]])

export default __exports__